import { Radio, RadioReceiver } from "lucide-react";
import { useEffect, useState } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useAdminWSStatus } from "@/lib/adminWS";

/**
 * Badge compacto que indica se o painel está conectado ao WebSocket.
 * - Verde pulsante: conectado (recebendo eventos em tempo real)
 * - Cinza: desconectado (polling de fallback assumiu)
 *
 * Pra ser plugado no header global do painel admin.
 */
export default function WSStatusBadge() {
  const { connected, connectedAt } = useAdminWSStatus();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 10_000);
    return () => clearInterval(id);
  }, []);

  const since = connectedAt
    ? `Conectado há ${Math.max(1, Math.floor((now - connectedAt) / 1000))}s`
    : "Desconectado, usando atualizações periódicas (5s)";

  return (
    <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          data-testid="ws-status-badge"
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold border transition-colors ${
            connected
              ? "bg-emerald-50 text-emerald-700 border-emerald-200"
              : "bg-gray-100 text-gray-500 border-gray-200"
          }`}
        >
          <span className="relative inline-flex">
            {connected ? (
              <>
                <span className="absolute inline-flex h-2 w-2 rounded-full bg-emerald-500 opacity-75 animate-ping" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
              </>
            ) : (
              <span className="relative inline-flex h-2 w-2 rounded-full bg-gray-400" />
            )}
          </span>
          {connected ? (
            <>
              <Radio size={11} />
              <span>Tempo real</span>
            </>
          ) : (
            <>
              <RadioReceiver size={11} />
              <span>Offline</span>
            </>
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="text-xs">
        {connected
          ? `WebSocket ativo · ${since}`
          : "WebSocket desconectado, usando polling. Tentando reconectar..."}
      </TooltipContent>
    </Tooltip>
    </TooltipProvider>
  );
}
